type VariantStockInfo = {
  manage_inventory?: boolean | null;
  allow_backorder?: boolean | null;
  inventory_quantity?: number | null;
};

export function isVariantInStock(variant: VariantStockInfo): boolean {
  if (!variant.manage_inventory) return true;
  if (variant.allow_backorder) return true;
  return (variant.inventory_quantity ?? 0) > 0;
}
